import { gql } from "@apollo/client/core";

export const LAWCASE_CLIENT_QUERY = gql`
  query ($lawcaseId: ID!) {
    lawcaseClient(lawcaseId: $lawcaseId) {
      id
      title
      description
      insertedAt
      events {
        id
        date
        eventTime
        description
        title
        category
        insertedAt
      }
      folders(rootFolderId: null) {
        id
        name
        countDocuments
        countFolders
        documents {
          id
          title
          description
          insertedAt
          hasRead
        }
      }
      documents(rootFolder: true) {
          id
          title
          description
          filePath
          fileExtension
          thumbnailSource
          insertedAt
          hasRead
        }
    }
  }
`;

export const LAWCASE_DOCUMENT_SUBSCRIPTION = gql`
  subscription ($lawcaseId: ID!) {
    documentEncrypted(lawcaseId: $lawcaseId) {
      id
      filePath
      thumbnailSource
      textContent
    }
  }
`;
